import amplitude from 'amplitude-js'
import { decamelizeKeys } from 'humps'

const sendData = (eventType: string, eventProperties: object = {}) => {
  amplitude.getInstance().logEvent(eventType, decamelizeKeys(eventProperties))
}

export default sendData
